import { get } from 'lodash';

import { songServices } from '@/services';

export const getSongUploadUrlsAction = async ({ payload }: { payload: any }) => {
  try {
    const response = await songServices.getSongUploadUrls(payload);
    return {
      success: true,
      data: get(response, 'data.data', {}),
    };
  } catch (error) {
    return {
      success: false,
      data: get(error, 'response.data', {}),
    };
  }
};

export const uploadSongAction = async ({ payload }: { payload: any }) => {
  try {
    const response = await songServices.songUpload(payload);
    return {
      success: true,
      data: get(response, 'data.data', {}),
    };
  } catch (error) {
    return {
      success: false,
      data: get(error, 'response.data', {}),
    };
  }
};

export const fetchSongsAction = async (id: string) => {
  try {
    const response = await songServices.fetchSongs(id);
    return {
      success: true,
      data: get(response, 'data.data', {}),
    };
  } catch (error) {
    return {
      success: false,
      data: get(error, 'response.data', {}),
    };
  }
};
